export default __webpack_public_path__ + "ceeef150ec35b37152e68bb70e1eb3e9.png";